export default __webpack_public_path__ + "static/media/thunderstorm.e2efa0c4.png";